import { useState } from 'react'
import { post } from '../../../../../utils/Api'
import { useGlobalContext } from '../../../../../utils/Context'
import FormLoader from '../../../../../components/loader/FormLoader'
import { Icon } from '@iconify/react'

interface Props {
  invoiceId: string
  totalAmount: number
  onClose: () => void
  onSuccess: () => void
}

function MarkPaidModal({ invoiceId, totalAmount, onClose, onSuccess }: Props) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const [note, setNote] = useState('')

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
    }).format(amount)
  }

  const handleMarkPaid = async () => {
    setLoading(true)

    try {
      const response = await post(
        `admin/weight-discrepancy/invoices/${invoiceId}/mark-paid`,
        {
          invoiceId,
          note: note.trim() || undefined,
        },
        null,
      )

      if (response.status === 200) {
        notify('success', 'Invoice marked as paid')
        onSuccess()
        onClose()
      } else {
        notify('error', response.message || 'Failed to mark invoice as paid')
      }
    } catch (error) {
      notify('error', 'Failed to mark invoice as paid')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='modal-overlay'>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Mark Invoice as Paid</h2>
          <button className='close-btn' onClick={onClose}>
            <Icon icon='mdi:close' />
          </button>
        </div>

        <div className='modal-body'>
          <div
            style={{
              textAlign: 'center',
              padding: '20px 0',
            }}
          >
            <Icon
              icon='mdi:check-circle'
              style={{
                fontSize: '64px',
                color: '#4caf50',
                marginBottom: '20px',
              }}
            />
            <h3 style={{ marginBottom: '10px' }}>Confirm Payment</h3>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              This will mark the invoice as fully paid and clear the user's
              weight discrepancy balance.
            </p>
          </div>

          <div
            className='check-result'
            style={{ backgroundColor: '#e8f5e9', marginBottom: '20px' }}
          >
            <div className='result-row'>
              <span>Amount to Mark as Paid</span>
              <span style={{ color: '#4caf50', fontWeight: 600 }}>
                {formatCurrency(totalAmount)}
              </span>
            </div>
          </div>

          <div className='form-group'>
            <label>Payment Note (Optional)</label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder='e.g., Payment received via bank transfer - Reference: TRF/2026/001234'
            />
            <p className='helper-text'>
              Add a note about how payment was received (bank transfer, cash,
              etc.)
            </p>
          </div>

          <div
            style={{
              backgroundColor: '#ffebee',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '20px',
            }}
          >
            <p style={{ margin: 0, fontSize: '14px', color: '#c62828' }}>
              <Icon
                icon='mdi:alert-circle'
                style={{ marginRight: '8px', verticalAlign: 'middle' }}
              />
              This action cannot be undone. Make sure payment has been received
              before proceeding.
            </p>
          </div>

          <div className='modal-actions'>
            <button className='btn-secondary' onClick={onClose}>
              Cancel
            </button>
            {loading ? (
              <FormLoader position='center' />
            ) : (
              <button className='btn-success' onClick={handleMarkPaid}>
                <Icon icon='mdi:check' style={{ marginRight: '5px' }} />
                Confirm Payment
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarkPaidModal
